export default __webpack_public_path__ + "static/media/timer.1468a945.svg";